import type { Desafio } from '../../types/quiz.types';
import { buildAssetUrl } from '../../utils/assetUrl';

interface Props {
  desafio: Desafio;
  onComplete: (sucesso: boolean) => void;
}

export function RostoHistoriaMinigame({ desafio, onComplete }: Props) {
  const opcoes = desafio.opcoes ?? ['Opção A', 'Opção B', 'Opção C'];
  const recompensa = desafio.recompensa?.moedas ?? 0;
  const imageUrl = buildAssetUrl(desafio.imagem_url);
  const showFallback = !desafio.imagem_url;

  return (
    <div className="w-full flex flex-col justify-between gap-2 sm:gap-3 select-none">
      <p className="text-slate-300 text-fluid-body leading-tight text-center sm:text-left font-medium">
        {desafio.instrucao}
        {recompensa > 0 ? ` (acerto garante +${recompensa} Axé extra)` : ''}
      </p>

      <div className="w-full h-[clamp(6rem,14dvh,11rem)] bg-slate-900 rounded-xl border border-slate-700 flex flex-col items-center justify-center overflow-hidden relative shadow-inner shrink-0">
        {showFallback ? (
          <div className="text-center p-2">
            <span className="text-2xl sm:text-3xl opacity-40 mb-1 block">👤</span>
            <span className="text-slate-500 text-fluid-sm italic break-words px-2">
              {desafio.imagem_url ? `Missing: ${desafio.imagem_url}` : 'Mídia não anexada ao desafio'}
            </span>
          </div>
        ) : (
          <img
            src={imageUrl || ''}
            alt="Personagem Misterioso"
            className="w-full h-full object-cover blur-md opacity-80"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.parentElement?.classList.add('flex', 'flex-col', 'items-center', 'justify-center');
              if (e.currentTarget.nextElementSibling) {
                e.currentTarget.nextElementSibling.classList.remove('hidden');
              }
            }}
          />
        )}
        {!showFallback && (
          <div className="hidden text-center p-2 absolute z-10">
            <span className="text-2xl opacity-30 mb-1 block">📡</span>
            <span className="text-amber-500/80 text-[10px] font-bold uppercase tracking-wider block mb-1">Upload Pendente</span>
            <span className="text-slate-500 text-[9px] break-all max-w-[200px]">{desafio.imagem_url}</span>
          </div>
        )}
      </div>

      <div className="grid gap-1.5 sm:gap-2">
        {opcoes.map((op, i) => (
          <button
            key={i}
            onClick={() => onComplete(i === (desafio.resposta_correta ?? 0))}
            className="btn-cyber w-full p-2 sm:p-2.5 min-h-[clamp(2.75rem,6.5dvh,4rem)] rounded-xl border text-slate-200 bg-slate-900 border-slate-700 shadow-md text-left hover:bg-amber-500 hover:text-slate-950 hover:border-amber-400 transition-colors font-medium text-fluid-body flex items-center"
          >
            <span className="text-amber-400 font-cyber font-bold mr-2 text-fluid-sm">{(i + 1).toString().padStart(2, '0')}.</span>
            <span className="flex-1 leading-snug">{op}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
